/**
 * Знак ChronoGuessr: роза ветров с часами в центре — место и время.
 *
 * Отдаётся файлом из public, а не встроенным SVG. Это вариант для малых
 * размеров — тот же, что во вкладке: обрезан по диску и без мелких делений,
 * которые в 32 px сливаются в рябь. Полный рисунок лежит в /logo.svg.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return <img src="/logo-mark.svg" width={size} height={size} alt="" aria-hidden className="shrink-0" />;
}
